import { render, staticRenderFns } from "./LearnerReport.vue?vue&type=template&id=32718174&"
import script from "./LearnerReport.vue?vue&type=script&lang=js&"
export * from "./LearnerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32718174')) {
      api.createRecord('32718174', component.options)
    } else {
      api.reload('32718174', component.options)
    }
    module.hot.accept("./LearnerReport.vue?vue&type=template&id=32718174&", function () {
      api.rerender('32718174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/LearnerReport.vue"
export default component.exports